import "./ShowCategory.css";

import { Breadcrumb, Button, message } from "antd";
import { BiEdit } from "react-icons/bi";
import { BsTrash } from "react-icons/bs";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { deleteCategory, useAppSelector } from "../../../_lib/_store";

export const ShowCategoryPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading } = useAppSelector((state) => state.package);

  const navigate = useNavigate();
  const { state } = useLocation();

  const categoryObj = state?.category;

  const handleDelete = async () => {
    const res = await deleteCategory(messageApi, categoryObj?.id);
    if (res) {
      navigate("/category");
    }
  };

  return (
    <>
      {contextHolder}
      <div className="createCategory">
        <Breadcrumb
          items={[
            {
              title: <Link to="/dashboard">Dashboard</Link>,
            },
            {
              title: <Link to="/category">Category</Link>,
            },
            {
              title: "Show",
            },
          ]}
        />

        <div className="titleHeader">
          <h2 className="title">Show</h2>
          <div className="actionButton">
            <Button
              icon={<BiEdit />}
              size="large"
              onClick={() =>
                navigate(`/category/edit`, {
                  state: { category: state?.category },
                })
              }
            >
              Edit
            </Button>
            <Button
              icon={<BsTrash />}
              size="large"
              onClick={handleDelete}
              loading={isLoading}
            >
              Delete
            </Button>
          </div>
        </div>

        <div className="form">
          <div className="row">
            <p className="label">Name</p>
            <p className="value">{categoryObj?.name}</p>
          </div>
          <div className="row">
            <p className="label">Id</p>
            <p className="value">{categoryObj?.id}</p>
          </div>
          <div className="row">
            <p className="label">Description</p>
            <p className="value">{categoryObj?.description}</p>
          </div>
          <div className="row">
            <p className="label">Tags</p>
            <div className="tagBox">
              {categoryObj?.tags?.map((v: string, i: number) => {
                return (
                  <div key={i} className="row">
                    <p className="label">{i + 1}</p>
                    <p className="value">{v}</p>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="row">
            <p className="label">Package Id</p>
            <p className="value">{categoryObj?.package?.name}</p>
          </div>
        </div>
      </div>
    </>
  );
};
